
import { BASE_URL, REACT_APP_PRIVATE_KEYCLOAK_AUTH_URL } from "../../services/apis/config";
import { get } from "../../services/httpMethods";
import fetcher from "../../services/fetcher";
import { CLIENT_ID, CLIENT_SECRET } from "../../services/apis/config";

const authHeader = `Basic ${btoa(`${CLIENT_ID}:${CLIENT_SECRET}`).replace(/(\r\n|\n|\r)/gm, '')}`;

export const authenticationApi = (data: any) => {
  var formData = new URLSearchParams();
  for (var k in data) {
    formData.append(k, data[k]);
  }

  return fetcher(POST_LOGIN)(formData);

};

export const getUsersApi = () => {
  return get(
    `${BASE_URL}/api/user-refs`);
};

// export const useAuthentication = () => {

//   const mutation = useMutation((data:any) => {
//     const formData = new URLSearchParams();
//     for (const k in data) {
//       formData.append(k, data[k]);
//     }
//     formData.append('client_secret', CLIENT_SECRET);
//     formData.append('client_id', CLIENT_ID);
//     formData.append('grant_type', 'password');
//     return axios.post(REACT_APP_PRIVATE_KEYCLOAK_AUTH_URL, formData, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
//       },
//     });
//   });

//   return mutation;
// };

export const POST_LOGIN: any = {
  url: `${REACT_APP_PRIVATE_KEYCLOAK_AUTH_URL}`,
  method: 'POST',
  queryKey: 'POST_LOGIN',
  headers: {
    'Authorization': authHeader,
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  isKeycloak: true,
};
